import puzzlesJson from './data/puzzles.json';
import openingsJson from './data/openings.json';
import { detectOpening } from './data/openings-detector';
import { OPENING_EXERCISES, getExercisesByTag, getExercisesByOpening } from './data/opening-exercises';
export const PUZZLES_DATA = puzzlesJson;
export const OPENINGS_DATA = openingsJson;
export { detectOpening, OPENING_EXERCISES, getExercisesByTag, getExercisesByOpening };
